module.exports = __webpack_public_path__ + "media/images/thumb/flags/16/CF-968631bb8d0a84469cca6745e3f6b557.png";